export const hourlyCalendar = {
  title: "Calendario a ore",
  navSubtitle: "Vendita a ore del tuo hotel",
  hotel: "Hotel",
  rooms: "Camere",
  roomsAbbr: "cam.",
  noDisp: "Non disp.",
  footer: {
    free: "{n} libere",
    occupied: "{n} occupate",
    cleaning: "{n} in pulizia",
    timezone: "Fuso orario: {tz}",
  },
  today: "Oggi",
  prevDay: "Giorno precedente",
  nextDay: "Giorno successivo",
  newStay: "Nuovo soggiorno",
  settingsBtn: "Impostazioni della vendita a ore",
  retry: "Riprova",
  dragHint: "Trascina su una camera per creare un soggiorno",
  groupFree: "{free} di {total} libere",
  zoom: { label: "Zoom", compact: "Compatta", normal: "Normale", wide: "Ampia" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Libere ora",
    occupied: "Occupate",
    cleaning: "In pulizia",
    arrivals: "Arrivano entro 1 h",
    overdueAlert: "1 camera ha superato l'orario | {n} camere hanno superato l'orario",
  },
  state: {
    free: "Libera",
    freeNext: "Libera · prossima {time}",
    soon: "Arriva alle {time}",
    occupied: "Occupata",
    occupiedLeft: "Occupata · mancano {time}",
    overdue: "Oltre di {time}",
    due: "In attesa di ingresso",
    cleaning: "Pulizia · {time}",
    closed: "Chiusa",
    maintenance: "Fuori servizio",
  },
  status: {
    booked: "Prenotato",
    in_house: "In corso",
    checked_out: "Terminato",
    cancelled: "Annullato",
    no_show: "Non presentato",
  },
  block: {
    noName: "Senza nome",
    blocked: "Bloccata",
    night: "Notte",
    closed: "Chiusa",
    maintenance: "Fuori servizio",
    left: "Mancano {time}",
  },
  legend: {
    booked: "Prenotato",
    inHouse: "In corso",
    overdue: "Orario superato",
    cleaning: "Pulizia",
    night: "Prenotazione a notte",
    closed: "Chiusa",
  },
  rangeMenu: {
    create: "Crea soggiorno",
    createSub: "Nell'orario selezionato",
    block: "Blocca questo orario",
    blockSub: "La camera non si vende in quell'intervallo",
    closeDay: "Chiudi la camera tutto il giorno",
    closeDaySub: "Quel giorno questa camera non si vende",
  },
  blockMenu: {
    editReason: "Cambia il motivo",
    editReasonSub: "Si vede nel calendario",
    remove: "Togli il blocco",
    removeSub: "La camera torna in vendita",
  },
  blockModal: {
    titleRange: "Blocca questo orario",
    titleDay: "Chiudi la camera",
    titleEdit: "Motivo del blocco",
    msgRange: "{room} non sarà venduta dalle {range}.",
    msgDay: "{room} non sarà venduta il {date}.",
    msgDayRest: "{room} non si venderà per il resto della giornata (dalle {time}).",
    msgEdit: "{room}",
    reasonLabel: "Motivo",
    reasonHint: "(si vede nel calendario)",
    placeholder: "Manutenzione, uso proprio…",
    cancel: "Annulla",
    block: "Blocca",
    save: "Salva",
    presetMaintenance: "Manutenzione",
    presetOwner: "Uso del proprietario",
    presetRepair: "Ristrutturazione",
    presetDeepClean: "Pulizia a fondo",
    presetClosed: "Chiusa",
  },
  drawer: {
    close: "Chiudi",
    closeBtn: "Chiudi",
    newTitle: "Nuovo soggiorno",
    newPill: "Nuovo",
    when: "Quando",
    room: "Camera",
    start: "Ingresso",
    end: "Uscita",
    nextDay: "giorno dopo",
    duration: "Durata",
    other: "Altra",
    free: "Camera libera in quell'orario",
    freeWithCleaning: "Libera · si tengono {n} min per pulire all'uscita",
    freeWillClose: "Libera · poi resta chiusa fino alle {hour}",
    busy: "Occupata dalle {from} alle {to}",
    busyClosed: "Chiusa dalle {from} alle {to}",
    busyMaintenance: "Camera fuori servizio",
    guest: "Cliente",
    guestName: "Nome",
    phone: "Telefono",
    optional: "Facoltativo",
    guests: "Persone",
    charge: "Pagamento",
    price: "Prezzo",
    method: "Metodo di pagamento",
    methods: { cash: "Contanti", card: "Carta", transfer: "Bonifico", other: "Altro" },
    paid: "Incassato",
    paidHint: "Hai già i soldi di questo soggiorno.",
    notes: "Note",
    notesPh: "Targa, richieste, tutto ciò che serve",
    guestTitle: "Registrazione dell'ospite",
    sendCheckin: "Inviare il link del check-in",
    sendCheckinHint: "Parte al salvare, al telefono dell'ospite.",
    sendCheckinNoPhone: "Scrivi il telefono dell'ospite per potergli mandare il check-in.",
    doCheckin: "Fare il check-in",
    edit: "Modificare",
    client: "Cliente",
    paidYes: "Incassato",
    paidNo: "Da incassare",
    markPaid: "Segnare come incassato",
    doCheckinHint: "Aprilo sul telefono dell'ospite o passagli il link: nome, cognome e documento, con scanner se vuole.",
    copyLink: "Copiare il link",
    copied: "Link copiato",
    checkinDone: "Check-in fatto · {n} ospite registrato | Check-in fatto · {n} ospiti registrati",
    checkinErrors: {
      no_reservation: "Accendi «Registrare i soggiorni come prenotazioni» nelle impostazioni per poter chiedere il check-in.",
      no_phone: "Scrivi il telefono dell'ospite per poterglielo mandare.",
      send_failed: "Non è stato possibile inviarlo. Prova a copiare il link e passarglielo tu.",
      not_requested: "Non è stato possibile inviarlo. Prova a copiare il link e passarglielo tu.",
    },
    checkinSent: "Check-in inviato",
    sendCheckinFailed: "Non è stato possibile inviare il check-in. Controlla il telefono dell'ospite.",
    save: "Salva",
    saveAndIn: "Salva e registra ingresso",
    saveChanges: "Salva modifiche",
    checkIn: "Registra ingresso",
    checkOut: "Registra uscita",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Altro",
    extendHow: "Prolunga",
    extendApply: "Prolunga",
    cancelBtn: "Annulla",
    checkOutNotYet: "L'uscita si potrà registrare quando inizi il soggiorno",
    confirmEarlyOutTitle: "Il soggiorno non è ancora iniziato",
    confirmEarlyOut: "Questo soggiorno inizia più tardi. Registrare l uscita ora lo chiude e libera la camera. Se il cliente non è venuto, usa «Non presentato».",
    noShow: "Non presentato",
    cancelStay: "Annulla soggiorno",
    keep: "Indietro",
    confirmCancel: "Si annulla e la camera resta libera in quell'orario. Non si può tornare indietro.",
    confirmNoShow: "La fascia torna libera per la vendita. Resta annotato che il cliente non è venuto.",
    confirmNoShowInHouse: "Risultava dentro, ma non è mai salito: si annulla l'arrivo e la fascia torna libera.",
    confirmCancelInHouse: "Risultava dentro: si annulla l'arrivo, si annulla il soggiorno e la camera resta libera. Non si può tornare indietro.",
    confirmNoShowTitle: "Non si è presentato?",
    confirmCancelTitle: "Annullare il soggiorno?",
    remaining: "Mancano {time}",
    overdue: "Ha superato l'orario di {time}",
    startsIn: "Inizia tra {time}",
    waiting: "L'orario è già iniziato: in attesa di ingresso",
    closedInfo: "Soggiorno chiuso: si possono modificare solo pagamento e note.",
    night: {
      title: "Prenotazione a notti",
      dates: "Dal {from} al {to}",
      code: "Codice",
      channel: "Canale",
      hint: "Le prenotazioni a notti si gestiscono dal calendario dell'hotel. Compaiono qui perché nessun soggiorno a ore si sovrapponga.",
      open: "Vai al calendario dell'hotel",
    },
  },
  settings: {
    title: "Vendita a ore",
    enable: "Vendere a ore",
    subtitle: "Come questo hotel vende a ore",
    offTitle: "Se la disattivi",
    offBody: "Il calendario a ore non sarà più disponibile e l'hotel torna a funzionare come prima. Non si cancella nulla.",
    offBodyStays: "Hai {n} soggiorni a ore in arrivo: non si cancellano, ma non li vedrai finché non la riattivi.",
    enabledOn: "Attiva: il calendario a ore è in uso",
    enabledOff: "Disattivata",
    requirements: "Requisiti",
    req: {
      rooms: "Camere create ({n})",
      channels: "Nessun canale di vendita collegato",
      ical: "Nessun calendario iCal sincronizzato",
      web: "Prenotazione online disattivata",
      nights: "{n} prenotazioni a notti future: compariranno nel calendario e bloccheranno le loro camere",
    },
    reqWhy: "Canali, iCal e sito vendono notti e non sanno nulla di ore: con uno di questi attivo, la stessa camera potrebbe essere venduta due volte.",
    cleaning: "Pulizia tra i soggiorni",
    cleaningHint: "Si riserva automaticamente dopo ogni uscita.",
    pending: "In attesa di pulizia",
    pendingHint: "Quando un cliente esce, la camera resta segnata «da pulire» in Pulizie e nell'app per questo tempo. NON blocca la vendita: se entra qualcuno prima, la pulisci allora.",
    none: "nessuna",
    minutes: "min",
    hours: "h",
    closeTitle: "Chiudere fino all'orario di apertura",
    closeHint: "Per quando non si pulisce subito: la camera resta chiusa e nessuno può venderla finché non apri.",
    closeAfterStay: "Alla fine di un soggiorno, lasciare la camera chiusa",
    closeAfterStayHint: "Si chiude da sola fino all'orario di apertura del giorno dopo. Se la pulisci prima, premi «È pulita» e torna in vendita subito.",
    afterTitle: "Dopo ogni soggiorno",
    afterHint: "Per quanto tempo la camera smette di essere venduta quando esce un cliente.",
    untilOpening: "Fino all'apertura",
    reopenHour: "Orario di apertura della vendita",
    reopenNote: "Le camere sporche tornano in vendita alle {hour}.",
    markClean: "È pulita",
    markCleanHint: "Apre la camera adesso, senza aspettare l'orario di apertura.",
    closeThisStay: "Lasciare la camera chiusa alla fine",
    closeThisStayHint: "Non si potrà vendere fino alle {hour}. L'orario, nelle impostazioni.",
    dayStart: "Inizio della giornata del calendario",
    dayRange: "dalle {from} alle {from} del giorno dopo",
    dayStartHint: "Scegli l'ora di minor movimento: così la notte si vede intera.",
    quickHours: "Durate rapide",
    quickHoursHint: "Compaiono come scorciatoie quando crei un soggiorno (fino a 6).",
    guestTitle: "Registrazione dell'ospite",
    asReservation: "Registrare i soggiorni come prenotazioni",
    asReservationHint: "Ogni soggiorno crea la sua prenotazione: così il denaro compare nei tuoi report e puoi richiedere il check-in e la schedina alloggiati. Se lo disattivi, le vendite a ore non entrano nei tuoi ricavi.",
    checkinDefault: "Chiedere il check-in per impostazione predefinita",
    checkinDefaultHint: "L'interruttore nella scheda del soggiorno sarà già acceso.",
    guestHint: "Queste prenotazioni non ricevono gli avvisi pensati per le notti (benvenuto, arrivo, partenza o recensione): il link del check-in si manda quando lo chiedi tu.",
    save: "Salva impostazioni",
    saved: "Impostazioni salvate",
  },
  empty: {
    eyebrow: "Vendita a ore",
    title: "Vendi le tue camere a ore",
    body: "Un calendario pensato per motel e hotel di soggiorni brevi: vedi ogni camera al minuto, crei soggiorni trascinando e la pulizia tra uno e l'altro si riserva da sola.",
    point1: "Stato di ogni camera in tempo reale",
    point2: "Trascina per creare, spostare o prolungare",
    point3: "Pulizia tra i soggiorni, automatica",
    cta: "Attiva la vendita a ore",
    ctaBlocked: "Soddisfa i requisiti per attivarla",
    noHotelsTitle: "Non hai ancora un hotel",
    noHotels: "La vendita a ore funziona con strutture di tipo hotel che hanno camere create.",
  },
  guide: {
    open: "Manuale d'uso",
    title: "Come funziona il calendario a ore",
    subtitle: "L'essenziale in un minuto: creare soggiorni, registrare arrivi e partenze e chiudere le camere che non vendi.",
    createTitle: "Creare un soggiorno",
    createBody: "Trascina sulla riga della camera, dall'ora di arrivo a quella di partenza. Puoi anche premere «Nuovo soggiorno» e scrivere gli orari a mano.",
    moveTitle: "Spostare e prolungare",
    moveBody: "Trascina la barra per cambiarle ora o camera. Tirando il bordo destro allunghi o accorci il soggiorno. Se lo spazio è occupato, il calendario non ti lascia rilasciarla.",
    checkinTitle: "Arrivo e partenza",
    checkinBody: "Apri il soggiorno e registra l'arrivo quando l'ospite arriva e la partenza quando se ne va. Se supera l'orario, la barra diventa rossa con i minuti in più.",
    cleaningTitle: "Pulizia tra un soggiorno e l'altro",
    cleaningBody: "Dopo ogni partenza si prenota da sola la fascia di pulizia che hai impostato. In quel lasso di tempo non può entrare nessuno.",
    blockTitle: "Bloccare un orario o chiudere la camera",
    blockBody: "Seleziona un intervallo e scegli «Blocca questo orario», oppure «Chiudi la camera tutto il giorno» se quel giorno non la vendi. Premi sul blocco per cambiarne il motivo o toglierlo.",
    settingsTitle: "Impostazioni",
    settingsBody: "Con l'ingranaggio imposti il tempo di pulizia, l'ora in cui inizia la giornata del calendario e le durate rapide che vedi quando crei un soggiorno.",
    colorsTitle: "Cosa significa ogni colore",
    colors: {
      booked: "Creato, l'ospite non è ancora arrivato",
      inHouse: "L'ospite è in camera",
      overdue: "Oltre l'orario di uscita",
      cleaning: "Fascia riservata alle pulizie",
      night: "Arriva dal calendario per notti",
      closed: "Bloccata o chiusa a mano",
    },
    otasTitle: "Prenotazioni per notti e canali",
    otasBody: "Le prenotazioni per notti si vedono qui per sapere quali camere sono occupate, ma si gestiscono nel calendario dell'hotel. Finché vendi a ore, questa struttura non si collega alle OTA.",
    gotIt: "Ho capito",
  },
  toasts: {
    created: "Soggiorno creato",
    checkedIn: "Ingresso registrato",
    checkedOut: "Uscita registrata · pulizia in corso",
    updated: "Modifiche salvate",
    extended: "Soggiorno prolungato",
    cancelled: "Soggiorno annullato",
    noShow: "Segnato come non presentato",
    moved: "Soggiorno spostato",
    resized: "Durata aggiornata",
    activated: "Vendita a ore attivata",
    blocked: "Orario bloccato",
    blockUpdated: "Motivo aggiornato",
    blockRemoved: "Blocco rimosso",
    loadError: "Impossibile caricare il calendario a ore",
    error: "Impossibile salvare. Riprova.",
  },
  errors: {
    room_busy: "La camera è occupata dalle {from} alle {to}",
    hourly_disabled: "La vendita a ore non è attiva in questo hotel.",
    room_maintenance: "Questa camera è fuori servizio.",
    room_not_found: "Questa camera non appartiene a questo hotel.",
    invalid_duration: "La durata deve essere tra 30 minuti e 48 ore.",
    invalid_start: "L'orario di ingresso non è valido.",
    stay_closed: "Questo soggiorno è già chiuso: non si può spostare.",
    invalid_status: "Questa azione non è possibile nello stato attuale del soggiorno.",
    requirements_not_met: "Questo hotel non soddisfa ancora i requisiti per vendere a ore.",
    not_found: "Elemento non trovato. Ricarica la pagina.",
    generic: "Qualcosa è andato storto. Riprova.",
  },
};
